import { render, staticRenderFns } from "./SimplifyObservability.vue?vue&type=template&id=bac259fc&scoped=true"
import script from "./SimplifyObservability.vue?vue&type=script&lang=js"
export * from "./SimplifyObservability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac259fc",
  null
  
)

export default component.exports